import React, {useState, useEffect} from 'react';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    TextField,
    Button,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';
import axios from '../api';
import '../App.css';
import Tabela from './Elements/Tabela';
import Swal from 'sweetalert2';

const Main = ({children}) => {
    const [formValues, setFormValues] = useState({
        consultorio: '',
        ativo: true,
        usuario_id: '',
        flag: 'Disponivel',
    });

    const [error, setError] = useState(false);

    const [updated, setUpdated] = useState(0);

    const [medicoResponsavelConsultorio, setmedicoResponsavelConsultorio] =
        useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('/users', {timeout: 5000});
                setmedicoResponsavelConsultorio(response.data.data);
            } catch (e) {
                console.log(e);
            }
        };
        fetchData();
    }, []);

    const handleOptionChange = (event) => {
        setFormValues({
            ...formValues,
            usuario_id: event.target.value,
        });
    };

    function validateFields() {
        if (formValues.consultorio === '') {
            return false;
        }

        if (formValues.ativo === '') {
            return false;
        }

        if (formValues.usuario_id === '') {
            return false;
        }
        return true;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        // verifica se as informações foram preenchidas
        const isValid = validateFields();
        setError(!isValid);

        if (isValid) {
            const token = localStorage.getItem('token');

            axios.post('/consultorios', formValues, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((response) => {
                    // exibe mensagem de sucesso com cor verde
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Cadastrado com sucesso',
                    });

                    // Atualiza o estado de atualização da tabela
                    setUpdated(!updated);
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro!',
                        text: error.response.data.error,
                    });
                });
        }

    };
    return (
        <main style={{marginLeft: '250px', padding: '20px'}}>
            {children}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Card>
                        <form onSubmit={handleSubmit}>
                            <CardHeader title="Cadastro de Consutórios"/>
                            <CardContent className={"formularios"}>
                                <Grid container spacing={3}>
                                    <Grid item xs={5}>
                                        <InputLabel style={{padding: '0.6rem'}}>Consultório</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            placeholder="Consultório"
                                            size="small"
                                            variant="outlined"
                                            inputProps={{maxLength: 50}} // adiciona o atributo maxlength diretamente no input
                                            value={formValues.consultorio}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    consultorio: event.target.value,
                                                })
                                            }
                                            error={error}
                                            helperText={error ? 'O Consultório deve ser preenchido.' : ''}
                                        />
                                    </Grid>
                                    {/*seleciona o doutor que esta neste consultorio.*/}
                                    <Grid item xs={4}>
                                        <InputLabel style={{padding: '0.5rem'}}>Médico responsável</InputLabel>
                                        <Select
                                            fullWidth
                                            id="outlined-required"
                                            value={formValues.doenca_id}
                                            onChange={handleOptionChange}
                                            variant="outlined"
                                            style={{height: '42px'}} // adicione esta linha
                                            displayEmpty
                                        >

                                            <MenuItem value="">Selecione</MenuItem>
                                            {medicoResponsavelConsultorio.map(medicoResponsavelConsultorio => (
                                                <MenuItem key={medicoResponsavelConsultorio.id}
                                                          value={medicoResponsavelConsultorio.id}>
                                                    {medicoResponsavelConsultorio.name}
                                                </MenuItem>

                                            ))}
                                        </Select>
                                        {error && <span style={{ color: 'red' }}>O médico responsavel pelo consultório deve ser selecionado.</span>}
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions>
                                <Button variant="contained" id="success" color='primary' type="submit">
                                    <i className="fa-solid fa-plus"></i> Salvar
                                </Button>
                            </CardActions>
                        </form>
                    </Card>
                </Grid>
            </Grid>
            <br/>
            <br/>
            <Card>
                <Tabela style={{padding: '50px'}}
                        key={updated}/> {/* adiciona o componente Tabela com a key atualizada */}
            </Card>
        </main>
    );
};

export default Main;